import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Form, Input, Switch, Button, Space, message, Row, Col } from "antd";
import {
  ArrowLeftOutlined,
  SaveOutlined,
  ReloadOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import userService from "../../services/userService";
import { useCommon } from "../../context/CommonContext";

const RolesCreateUpdate = () => {
  const { role_id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { setPageTitle } = useCommon();

  // State management
  const [loading, setLoading] = useState(false);

  const getRoleDetails = async () => {
    const response = await userService.getRoleById(role_id);
    console.log("responserole==>", response);
    const data = response.data.data;
    form.setFieldsValue(data);
  };

  useEffect(() => {
    if (role_id !== "new") {
        getRoleDetails();
    }
  }, [role_id]);

  useEffect(() => {
    setPageTitle(role_id === "new" ? "Create Role" : "Edit Role");
  }, []);

  // Handle form submission
  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      console.log("Submitting role data:", values);

      if (role_id !== "new") {
        const response = await userService.updateRole(role_id, values);
        console.log("responseupdate==>", response);
      } else {
        const response = await userService.createRole(values);
        console.log("responsecreate==>", response);
      }

      form.resetFields();
      navigate("/roles");
    } catch (error) {
      console.error("Error saving role:", error);
      message.error("Failed to save role");
    } finally {
      setLoading(false);
    }
  };

  // Handle form reset
  const handleReset = () => {
    form.resetFields();
  };

  // Handle go back
  const handleGoBack = () => {
    navigate("/roles");
  };

  return (
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        requiredMark={false}
        initialValues={{
          is_active: true,
        }}
      >
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item
              label="Role Name"
              name="name"
              rules={[
                { required: true, message: "Please enter role name" },
                {
                  min: 2,
                  message: "Role name must be at least 2 characters",
                },
                {
                  max: 50,
                  message: "Role name must not exceed 50 characters",
                },
              ]}
            >
              <Input placeholder="Enter role name" prefix={<TeamOutlined />} />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Active Status"
              name="is_active"
              valuePropName="checked"
              rules={[
                { required: true, message: "Please select active status" },
              ]}
            >
              <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
            </Form.Item>
          </Col>
        </Row>

        {/* Form Actions */}
        <Form.Item style={{ marginTop: "32px" }}>
          <Space>
            <Button
              type="primary"
              htmlType="submit"
              icon={<SaveOutlined />}
              loading={loading}
              size="large"
            >
              Save Role
            </Button>

            <Button
              icon={<ReloadOutlined />}
              onClick={handleReset}
              size="large"
            >
              Reset
            </Button>

            <Button
              icon={<ArrowLeftOutlined />}
              onClick={handleGoBack}
              size="large"
            >
              Go Back
            </Button>
          </Space>
        </Form.Item>
      </Form>
  );
};

export default RolesCreateUpdate;
